import { filter, find } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  selectedFleetId: -1,
  allFleets: []
}

export const getters = {
  selectedFleet: state => { return Number(state.selectedFleetId) !== -1 ? find(state.allFleets, fleet => fleet.id === state.selectedFleetId) : {} },
  selectedFleetId: state => state.selectedFleetId || -1,
  allFleets: state => state.allFleets
}

export const mutations = {
  setSelectedFleetId (state, selectedFleetId) {
    state.selectedFleetId = selectedFleetId
  },

  setAllFleets (state, allFleets) {
    // Remove fleets without customer
    state.allFleets = filter(allFleets, f => !!f.customer)
  }
}

export const actions = {
  // Save in localStorage and store
  saveSelectedFleetId (context, selectedFleetId) {
    localStorage.setItem(context.rootGetters.authenticatedUser.login + '-selectedFleetId', selectedFleetId)
    context.commit('setSelectedFleetId', selectedFleetId)
  },

  // Get all the fleets attached
  async getAllFleets (context) {
    let error, response
    [error, response] = await to(api.getAllFleets(context.rootGetters.application))
    if (error || !response) return

    context.commit('setAllFleets', response.data.list)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
